import React, { useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { setEmailHeader } from '../../../../bridge';
import { logError } from '../../../../helpers/logger';
import { __ } from '../../../../helpers/translations';

function SetEmailHeaderModal({
  surveyId, emailHeader, onChanged, onCancel,
}) {
  const [text, setText] = useState(emailHeader);

  const onClickSave = async () => {
    const cleanedText = text.trim();

    const { error } = await setEmailHeader(surveyId, cleanedText);
    if (error) {
      logError('set_email_header_on_click_save', error);
    } else {
      onChanged();
    }
  };

  return (
    <Modal show centered onHide={onCancel}>
      <Modal.Header>
        <Modal.Title>{__('G298')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="mb-6">
          <Form.Control
            as="textarea"
            autoFocus
            value={text}
            onChange={(e) => setText(e.target.value)}
            rows={10}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel}>
          {__('G106')}
        </Button>
        <Button variant="primary" onClick={onClickSave}>
          {__('G74')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

SetEmailHeaderModal.propTypes = {
  emailHeader: PropTypes.string,
  surveyId: PropTypes.string,
  onCancel: PropTypes.func,
  onChanged: PropTypes.func,
};

export default SetEmailHeaderModal;
